export default __webpack_public_path__ + "static/media/video_preview.efe3cb43.png";